import React from "react";
import ConfigurationForm from "./ConfigurationForm";

const ConfigurationPage = () => {
  return (
    <div className="sub-content">
      <ConfigurationForm />
    </div>
  );
};

export default ConfigurationPage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/configuration/ConfigurationPage.js